import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import up1 from '../../../../assets/icons/up1.svg';

import './Filter.css';

export default class Filter extends Component {
  render() {
    const { filters } = this.props;
    return (
      <div className="filter d-flex flex-column p-3">
        <div className="filter__title d-flex mr-3 mb-1">
          <div>تقویم من</div>
          <img src={up1} />
        </div>
        <div className="filter__list d-flex flex-column">
          {
            filters.map(item => (
              <div className="filter__list--item d-flex mt-1" key={item.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon
                        style={{ color: item.color }} />}
                      checkedIcon={<CheckBoxIcon
                        style={{ color: item.color }} />}
                      name={item.title} onChange={(e) => { console.log(e.target.name); }} />
                  }
                />
                <div className="mr-4">{item.name}</div>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}